// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bH2x","imageContainer":"styles_imageContainer__3he5c"};